import React from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import CustomHelmet from "../components/CustomHelmet";
import PackagesTable from "../components/Packages";

export default function Packages(props) {
  return (
    <div>
      <CustomHelmet page="Hubsquares Packages" />
      <Navbar user={props.user} />
      <div className="wrapper add_banner position-relative">
        <div className="overlay">
          <div className="banner">
            <div className=" text-center mt-6 container">
              <h1>HUBSQUARES PACKAGES</h1>
            </div>
          </div>
        </div>
      </div>

      <main className="my-4 container">
        <PackagesTable user={props.user} plan={true} props={props} />
        <div className="position-relative mb-5  py-2">
          <button
            className="text-white addbtn btn-danger btn  position-absolute bg-red"
            style={{
              right: 0,
            }}
            onClick={() => window.scrollTo(0, 0)}
          >
            {/* <i class="fa fa-caret-up" aria-hidden="true"></i> */}
            Back to top
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
